import { render, staticRenderFns } from "./tag_management.vue?vue&type=template&id=6708195b&scoped=true"
import script from "./tag_management.vue?vue&type=script&lang=js"
export * from "./tag_management.vue?vue&type=script&lang=js"
import style0 from "./tag_management.vue?vue&type=style&index=0&id=6708195b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708195b",
  null
  
)

export default component.exports